import React from 'react';
import FeatureRichList from '../Common/RichList/FeatureRichList';


const LinkedBank = ({setStep, step, data}) => {
	return (
		<FeatureRichList data={data || []} step={step} subClass='subClass' linkedPage setStep={setStep}/>
	);
};

export default LinkedBank;
